/**
 * Timbrica Site Search — header search engine.
 * Asks the page's search thread (search-thread.js), which owns the index.
 */
(function() {
    // Страница, отрисованная до 23.10.2026 (кэш края, копия service worker'а),
    // не знает тега search-thread.js, а этот файл приходит к ней сегодняшним.
    // Без потока молчали бы и шапка, и сайдбар, и помощник — догружаем его сами;
    // без window.__SEARCH_THREAD он отвечает с главного потока, как было раньше.
    if(!window.__searchThread){
        try{
            var st=document.createElement('script');
            st.src=typeof window.__jsSrc==='function'?window.__jsSrc('/js/search-thread.js'):'/js/search-thread.js';
            st.async=true;
            (document.head||document.documentElement).appendChild(st);
        }catch(e){}
    }
    var searchInput=document.getElementById('siteSearch');
    var searchResults=document.getElementById('searchResults');
    if(!searchInput||!searchResults)return;
    var _S={nm:searchInput.dataset.sNm,dy:searchInput.dataset.sDy,ba:searchInput.dataset.sBa,
            rq:searchInput.dataset.sRq,rqUrl:searchInput.dataset.sRqUrl};
    var _RT={};
    try{ _RT=JSON.parse(searchInput.dataset.sRt||'{}') }catch(e){}
    var _loc=window.__LOCALE||document.documentElement.lang||'en';
    var MAX_RESULTS=8;
    // На /search телеметрию поиска ведёт сам скрипт страницы. Хедер-дропдаун
    // там тоже живой (он подхватывает ?q= из URL), и до 2026-08-05 оба слали
    // свой `search_miss` — каждый промах на странице поиска считался дважды.
    function pageOwnsTelemetry(){ return !!window.__SEARCH_PAGE_TELEMETRY }
    function escHtml(s){
        return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
            .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
    // Debounced zero-result telemetry — surfaces discoverability gaps (a real,
    // settled query that finds no tool) so keyword gaps get captured
    // automatically instead of only via a user emailing "я не нашёл инструмент".
    // Оба таймера гасят друг друга: пока человек допечатывает, запрос успевает
    // побывать и пустым, и непустым, а событие должно уехать ровно одно —
    // про то состояние, на котором ввод остановился.
    var _missTimer=null;
    var _qTimer=null;

    // Индекс готовится и спрашивается в потоке поиска страницы
    // (search-thread.js): раньше шапка готовила его здесь, на главном потоке,
    // в момент первой буквы — 1,9 с стеммера одним куском на слабом ноутбуке.
    function renderResult(t){
        return '<a href="'+t.url+'" class="search-result" data-sc="'+t.name.replace(/"/g,'&quot;')+'"><div class="search-result-icon">'+t.icon+'</div><div class="search-result-text"><div class="search-result-title">'+t.name+'</div><div class="search-result-desc">'+t.desc+'</div></div></a>';
    }
    // «Такого инструмента нет — опишите, и мы его сделаем». Показываем только
    // там, где выдача действительно пустая (роутер и перебивка раскладки уже
    // не спасли) И строка похожа на фразу — гейт живёт в движке, см.
    // TimbricaSearch.requestable(). Запрос уезжает в ?q=, чтобы на форме не
    // пришлось набирать его заново.
    function requestToolLink(raw){
        if(!_S.rq||!_S.rqUrl)return '';
        var E=window.TimbricaSearch;
        if(!E||!E.requestable||!E.requestable(raw))return '';
        // Стрелка рисуется в CSS (::after): в RTL «вперёд» смотрит влево, а
        // зашитая в строку «→» на арабском показывала в конец строки.
        return '<a href="'+escHtml(_S.rqUrl)+'?q='+encodeURIComponent(raw)+'" class="search-request-tool" data-sc="request-tool">'+escHtml(_S.rq)+'</a>';
    }
    searchResults.addEventListener('click',function(e){
        // .search-request-tool ловим тем же слушателем: клик уезжает обычным
        // search_click с clicked='request-tool', поэтому конверсия «пустая
        // выдача → заявка» считается без нового типа события в ALLOWED_TYPES.
        var a=e.target.closest('.search-result,.search-request-tool');
        if(a&&window.__ae){
            var q=searchInput.value.trim();
            window.__ae('search_click',{q:q,clicked:a.dataset.sc||'',url:a.getAttribute('href')||''});
        }
    });
    function doSearch(query){
        // Один и тот же движок, что и на /search: раньше здесь был свой,
        // упрощённый скоринг, и одна строка давала два разных ответа.
        var T=window.__searchThread;
        if(!T)return;
        T.search(query,{tight:true,limit:MAX_RESULTS,rescue:true},function(r){
            if(searchInput.value.toLowerCase().trim()!==query)return;   // уже спросили следующее
            drawResults(query,r.res,r.fb);
        },'header');
    }
    function drawResults(query,scored,fb){
        // Спасение промаха: строка может быть ДАННЫМИ (номер рейса, IP,
        // штрихкод), текстом в чужой раскладке или слипшимися словами.
        // Разбирает движок — одна реализация на хедер, /search и сайдбар.
        //
        // ⚠️ Условие — rescue(), а НЕ `scored.length===0`. Выдача из одних
        // похожих по написанию (все с покрытием 0) — тоже промах, но по этому
        // счётчику она выглядела найденной, и спасение не пробовалось вовсе:
        // «фоторедактор» показывал «Порядок страниц PDF» вместо полки
        // редакторов фото (жалоба 27.08).

        if(scored.length===0||fb){

            // Log the miss ~1.2 s after typing settles (≥3 chars) — not every
            // partial keystroke. A later keystroke that finds results cancels it.
            // `r` — чем промах спасли: по нему считается польза роутера, и для
            // этого не нужен отдельный тип события.
            try {
                clearTimeout(_missTimer); clearTimeout(_qTimer); if(window.__aeDeferredCancel)window.__aeDeferredCancel('search_miss');
                var _mq=(query||'').trim();
                var _mr=fb?(fb.type==='route'?fb.kind:fb.type):'';
                // Через общий примитив: свой таймер терял ровно те промахи,
                // которые СПАСЛИСЬ, — карточка появляется мгновенно, клик
                // уводит со страницы, событие не уходит. См. `__aeDeferred`.
                if(_mq.length>=3&&!pageOwnsTelemetry()&&window.__aeDeferred)
                    window.__aeDeferred('search_miss','search_miss',{q:_mq.slice(0,60),loc:_loc,r:_mr},1200);
            } catch(e){}

            var html='';
            if(fb&&fb.type==='route'){
                html+='<a href="'+escHtml(fb.url)+'" class="search-result search-route" data-sc="route:'+escHtml(fb.kind)+'">'
                    +'<div class="search-result-icon">'+(fb.tool.icon||'')+'</div>'
                    +'<div class="search-result-text">'
                    +'<div class="search-result-desc">'+escHtml(_RT[fb.kind]||'')+'</div>'
                    +'<div class="search-result-title">'+escHtml(fb.tool.name)+' · '+escHtml(fb.value)+'</div>'
                    +'</div></a>';
            } else if(fb&&(fb.type==='layout'||fb.type==='split'||fb.type==='term')){
                if(fb.query)html+='<div class="search-suggestions-label">'+_S.dy+' '+escHtml(fb.query)+'</div>';
                html+=fb.results.slice(0,MAX_RESULTS).map(function(x){return renderResult(x.t)}).join('');
            } else {
                html+='<div class="search-no-results">'+_S.nm+'</div>';
                html+=requestToolLink(searchInput.value.trim());
                html+='<a href="/'+_loc+'" class="search-browse-all">'+_S.ba+'</a>';
            }
            searchResults.innerHTML=html;
        } else {
            try { clearTimeout(_missTimer); if(window.__aeDeferredCancel)window.__aeDeferredCancel('search_miss'); } catch(e){}
            // Знаменатель воронки. `search_query` числился в разрешённых типах
            // с самого начала, но НИКТО его не слал — в базе ноль строк, и доля
            // промахов от всех поисков не считалась вообще. Шлём его только для
            // непустой выдачи: пустую по-прежнему считает `search_miss`, так что
            // всего поисков = search_query + search_miss, без двойного учёта.
            try {
                clearTimeout(_qTimer);
                var _qq=(query||'').trim(), _qn=scored.length;
                if(_qq.length>=3&&!pageOwnsTelemetry()) _qTimer=setTimeout(function(){
                    try{ if(window.__ae) window.__ae('search_query',{q:_qq.slice(0,60),loc:_loc,n:_qn}); }catch(e){}
                },1200);
            } catch(e){}
            var visible=scored.slice(0,MAX_RESULTS);
            // Движок отдаёт похожие по написанию только когда точных нет —
            // тогда это не «результаты», а «возможно, вы имели в виду».
            var onlyFuzzy=visible.length>0&&visible.every(function(x){return x.fuzzy});
            var html=(onlyFuzzy?'<div class="search-suggestions-label">'+_S.dy+'</div>':'')
                +visible.map(function(x){return renderResult(x.t)}).join('');
            if(scored.length>MAX_RESULTS){
                html+='<a href="/'+_loc+'/search?q='+encodeURIComponent(searchInput.value.trim())+'" class="search-browse-all">+' + (scored.length-MAX_RESULTS) + '</a>';
            }
            searchResults.innerHTML=html;
        }
        searchResults.classList.add('active');
    }

    var _debounce=null;
    searchInput.addEventListener('input',function(){
        var self=this;
        clearTimeout(_debounce);
        _debounce=setTimeout(function(){
            var query=self.value.toLowerCase().trim();
            if(query.length<2){searchResults.classList.remove('active');return}
            doSearch(query);
        },80);
    });
    searchInput.addEventListener('focus',function(){
        if(window.__searchThread)window.__searchThread.start('header');
        if(this.value.length>=2&&searchResults.innerHTML)searchResults.classList.add('active');
    });
    document.addEventListener('click',function(e){if(!searchInput.contains(e.target)&&!searchResults.contains(e.target))searchResults.classList.remove('active')});
    // Одно действие «искать» на два входа — Enter и лупа. Раньше оно было
    // только у Enter, а лупа была декоративным svg. preventDefault нужен,
    // потому что строка теперь настоящая <form>: без него ушли бы ОБА перехода
    // (наш и нативный сабмит), причём на разные адреса — нативный шлёт ?q= даже
    // для одной буквы. Нативный сабмит остаётся запасным путём, когда этот
    // скрипт не доехал.
    function goSearch(){
        var q=searchInput.value.trim();
        window.location.href='/'+_loc+'/search'+(q.length>=2?'?q='+encodeURIComponent(q):'');
    }
    searchInput.addEventListener('keydown',function(e){
        if(e.key==='Escape'){searchResults.classList.remove('active');this.blur()}
        if(e.key==='Enter'){e.preventDefault();goSearch()}
    });
    var goBtn=document.getElementById('siteSearchGo');
    if(goBtn)goBtn.addEventListener('click',function(e){e.preventDefault();goSearch()});

    var urlQ=new URLSearchParams(location.search).get('q');
    if(urlQ){searchInput.value=urlQ;doSearch(urlQ.toLowerCase().trim());searchInput.focus()}
})();
